import DropdownHelper from "../Modules/Dropdown";
import {Tooltip} from "bootstrap";
import {asyncTimeout} from "../Functions/Timeout";

/**
 * Initialize user list select
 */
export class UserListSelect {
    private static instanceMap: Map<HTMLElement, UserListSelect> = new Map();

    protected select: HTMLSelectElement;
    protected button: HTMLButtonElement;
    protected fetchListsUrl: string;
    protected submitUrl: string;
    protected doneButton: HTMLButtonElement|null = null;

    constructor(element: HTMLElement) {
        this.select = element.querySelector('select.assign-to-list--select');
        this.button = element.querySelector('button.assign-to-list--button');
        this.fetchListsUrl = element.dataset.assignedListsUrl;
        this.submitUrl = this.select.dataset.link;

        if (!this.fetchListsUrl || !this.submitUrl) {
            return;
        }

        this.init();
    }

    /**
     * Initialize
     */
    protected init = () => {
        this.button.addEventListener('click', () => {
            this.toggleLoadingState();


            const request = async () => {
                const url = new URL(this.fetchListsUrl, window.location.origin);

                const response = await fetch(url);

                return response.json();
            }

            request()
                .then((data) => {
                    this.toggleLoadingState();
                    this.showSelect(data);
                })
                .catch((e) => {
                    this.toggleLoadingState();
                    console.error(e);
                });
        }, {passive: true});
    }

    /**
     * Toggle loading state
     */
    protected toggleLoadingState = () => {
        this.button.disabled = !this.button.disabled;

        this.button.querySelector('.default-label')?.classList.toggle('d-none');
        this.button.querySelector('.loading-label')?.classList.toggle('d-none');
    }

    /**
     * Show button
     */
    protected showButton = () => {
        $(this.select).selectpicker('destroy');
        this.select.classList.add('d-none');
        this.button.classList.remove('d-none');
    }

    /**
     * Show select
     *
     * @param data
     */
    protected showSelect = (data: any) => {
        this.button.classList.add('d-none');
        this.select.classList.remove('d-none');

        const select = $(this.select).selectpicker({
            selectedTextFormat: 'count',
            countSelectedText: (numberOfSelections: number, totalNumberOfOptions: number) => {
                return `${numberOfSelections} ausgewählt`;
            },
            container: false,
            size: 200,
        });

        if (data && data.length > 0) {
            $(this.select).selectpicker('val', data);
        }

        DropdownHelper.defaultInit();

        $(this.select).selectpicker('toggle');

        $(select).on('hidden.bs.select', this.showButton);

        this.doneButton = document.querySelector('.bootstrap-select.assign-to-list--select .bs-donebutton button');
        if (this.doneButton instanceof HTMLButtonElement) {
            this.doneButton.addEventListener('click', this.submitListener, {passive: true});
        }
    }

    /**
     * Submit listener
     */
    protected submitListener = () => {

        const selectedOptions = this.select.selectedOptions;

        if (selectedOptions.length === 0) {
            return;
        }

        const identifiers = [];
        for (let i = 0; i < this.select.selectedOptions.length; i++) {
            identifiers.push(this.select.selectedOptions[i].value);
        }

        this.doneButton.removeEventListener('click', this.submitListener);
        this.showButton();
        this.showButton();
        this.toggleLoadingState();

        const request = async (identifiers: any) => {
            const url = new URL(this.submitUrl, window.location.origin);
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ listIdentifiers: identifiers }),
            });

            return response.json();
        }

        request(identifiers)
            .then((data) => {
                this.toggleLoadingState();

                const tooltip = new Tooltip(this.button, {
                    trigger: 'manual',
                    placement: 'top',
                    title: this.button.dataset.success,
                    delay: {show: 500, hide: 100},
                });
                tooltip.show();
                asyncTimeout(() => {
                    tooltip.hide();
                }, 5000);

            })
            .catch((e) => {
                this.toggleLoadingState();

                const tooltip = new Tooltip(this.button, {
                    trigger: 'manual',
                    placement: 'top',
                    title: this.button.dataset.error,
                    delay: {show: 500, hide: 100},
                });
                tooltip.show();
                asyncTimeout(() => {
                    tooltip.hide();
                }, 5000);

                console.error(e);
            });
    }

    /**
     * Get or create a new UserListSelect
     *
     * @param element
     */
    public static getOrCreateInstance = (element: HTMLElement): UserListSelect => {
        if (!UserListSelect.instanceMap.has(element)) {
            UserListSelect.instanceMap.set(element, new UserListSelect(element));
        }

        return UserListSelect.instanceMap.get(element);
    }

    /**
     * Create UserListSelect instances from a list of elements or a selector
     *
     * @param elementList
     */
    public static createInstances = (elementList: NodeListOf<HTMLElement>|string) => {
        if (typeof elementList === 'string') {
            elementList = document.querySelectorAll(elementList);
        }

        if (elementList.length > 0) {
            elementList.forEach((el: HTMLElement) => {
                UserListSelect.getOrCreateInstance(el);
            });
        }
    }

    /**
     * Default initialization
     */
    public static defaultInit = () => {
        const elements: NodeListOf<HTMLElement> = document.querySelectorAll('.assign-to-list');

        UserListSelect.createInstances(elements);
    }
}

/**
 * Initialize user list select
 */
export function initUserListSelect() {
    UserListSelect.defaultInit();
}
